import { useCallback, useEffect, useState } from 'react';

import { getPromoCode } from '@/components/patient/checkout/checkout-actions';
import { useLocalforage } from '@/hooks/use-localforage';
import { DEFAULT_PROMO_PRICING, getPricingFromPromoCode } from '@/hooks/promo-pricing';

export const PROMO_CODE_KEY = 'promo-code';

export function usePromoCode() {
  const {
    values: [code],
    setItem,
    store,
  } = useLocalforage<[string]>([PROMO_CODE_KEY]);
  const setCode = useCallback((code: string) => setItem(PROMO_CODE_KEY, code), [setItem]);
  const [pricing, setPricing] = useState(DEFAULT_PROMO_PRICING);

  useEffect(() => {
    if (!code) {
      setPricing(DEFAULT_PROMO_PRICING);

      return;
    }

    let cancelled = false;

    setPricing(DEFAULT_PROMO_PRICING);

    getPromoCode(code)
      .then((promoCode) => {
        if (cancelled) {
          return;
        }

        setPricing(getPricingFromPromoCode(promoCode));
      })
      .catch(() => {
        if (!cancelled) {
          setPricing(DEFAULT_PROMO_PRICING);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [code]);

  return { code, pricing, setCode, isReady: !!store, hasDiscount: pricing.original !== pricing.discounted };
}
